import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { updAuth } from "features/auth";
import { login } from "features/dinamic";
import { setLoading } from "features/loader";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";

interface UserState {
    status: string;
    error: string;
    user: string;
    password: string;
}

const initialState: UserState = {
    status: 'idle',
    error: '',
    user: '',
    password: ''
}

export const fetchLogin = createAsyncThunk('fetchLogin', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const user = btoa(selectUser(state));
    const password = btoa(selectPassword(state));
    let alert: AlertInterface;

    try {
        const { result, message, data } = await login({ user, password }, getState, dispatch);
        
        if (result) {
            dispatch(updAuth({ token: data, idRol: message }));
            dispatch(setLoading(false));
            return { success: true, token: data, idRol: message };
        } else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
            dispatch(setDataToast(alert));
            dispatch(setVisibleToast(true));
            setTimeout(() => {
                dispatch(setVisibleToast(false));
            }, 4000);
            dispatch(setLoading(false));
            return rejectWithValue(message);
        }
    } catch (error: any) {
        dispatch(setLoading(false));
        alert = { title: 'ERROR', message: 'Error de conexión', data: [], type: 'Crimson', time: Date.now() };
        dispatch(setDataToast(alert));
        dispatch(setVisibleToast(true));
        setTimeout(() => {
            dispatch(setVisibleToast(false));
        }, 4000);
        return rejectWithValue('Error de conexión');
    }
});


export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setUser: (state, action) => {
            const { user, password } = action.payload;
            state.user = user || '';
            state.password = password || '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLogin.pending, (state) => {
                state.status = 'loading';
                state.error = '';
            })
            .addCase(fetchLogin.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.error = '';
            })
            .addCase(fetchLogin.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string || 'Login failed';
            });
    },
})

export const selectUser = (state: RootState) => state.login.user;
export const selectPassword = (state: RootState) => state.login.password;

export const { setUser } = loginSlice.actions;


export default loginSlice.reducer;